import { Writable, writable } from "svelte/store";
import type { RetailerUserAuthentication } from "@shared/types/RetailerUserAuthentication";

export const RetailerUserAuthenticationStoreNotifier = writable(false);

const _store: Writable<RetailerUserAuthentication[]> = writable([], () => {
  RetailerUserAuthenticationStoreNotifier.set(true);
  return () => {
    RetailerUserAuthenticationStoreNotifier.set(false);
  };
});

const { subscribe, set, update } = _store;

const RetailerUserAuthenticationsStore = {
  set,
  subscribe,
  update,
};

export default RetailerUserAuthenticationsStore;
